import React from 'react'
import {useTranslation} from 'react-i18next'

import {Container} from '~/components/general/container/Container'
import {Button} from '~/components/general/button/Button'
import {Typography} from '~/components/general/typography/Typography'
import FilteredSelect from '~/components/general/select/FilteredSelect'

type PatientsToolbarProps = {
  onPrevWeek: () => void
  onNextWeek: () => void
  serviceOptions: {label: string; value: string}[]
  selectedServiceId: string
  onServiceChange: (id: string) => void
  isExportDisabled: boolean
  onExportPdf: () => void
  onExportExcel: () => void
  showServiceFilter?: boolean
  showExports?: boolean
}

export const PatientsToolbar = ({
  onPrevWeek,
  onNextWeek,
  serviceOptions,
  selectedServiceId,
  onServiceChange,
  isExportDisabled,
  onExportPdf,
  onExportExcel,
  showServiceFilter = true,
  showExports = true,
}: PatientsToolbarProps) => {
  const {t} = useTranslation()
  return (
    <Container
      flex
      direction="row"
      justify="space-between"
      align="center"
      spacing={2}>
      <Container flex direction="row" spacing={2}>
        <Button onClick={onPrevWeek}>{t('Previous Week')}</Button>
        <Button onClick={onNextWeek}>{t('Next Week')}</Button>
        {showServiceFilter && (
          <Container flex align="center" spacing={1}>
            <Typography>{t('Service')}</Typography>
            <FilteredSelect
              width={300}
              placeholder={t('Select service')}
              options={serviceOptions}
              initialValue={
                serviceOptions.find((o) => o.value === selectedServiceId)
                  ?.label || ''
              }
              onChange={(value) => onServiceChange((value as string) || '')}
            />
          </Container>
        )}
      </Container>
      {showExports && (
        <Container flex direction="row" spacing={2}>
          <Button onClick={onExportPdf} disabled={isExportDisabled}>
            {t('Export PDF')}
          </Button>
          <Button onClick={onExportExcel} disabled={isExportDisabled}>
            {t('Export Excel')}
          </Button>
        </Container>
      )}
    </Container>
  )
}
